export default __webpack_public_path__ + "static/1050-2a78c7cf3138911ce15514c932688fe9.gif";